<ng-container *ngIf="bonusId$ | async as bonusId">
	<offers-my_offers_bonus_details [attr.bonus-id]="bonusId"></offers-my_offers_bonus_details>
</ng-container>
